import 'reflect-metadata'
import { createApp, defineComponent } from "vue";
import BaseComponent from '@base/component'
import LoginModel from '@models/login'
import { getUrlVars, makeUrl } from '@utils/query'
import ErrorsVue from '@components/errors/errors.vue'
import MsgsVue from '@components/msgs/msgs.vue'

var model = new LoginModel()

const ForgotPasswordComponent = defineComponent({
    mixins: [BaseComponent],
    components: {
        errors: ErrorsVue,
        msgs: MsgsVue
    },
    data() {
        return {
            model
        };
    },
    methods: {
        submit: function (evt) {
            evt.preventDefault();
            this.model.sync('submit');
            return false;
        }
    }
});

model.fetchData().then(data => {
    const forgotPasswordApp = createApp(ForgotPasswordComponent)
    forgotPasswordApp.mount("section#forgot-password")
});
